// Executive Brain feature flag (default OFF).
//
// When false, App.js does NOT register the /brain* routes and injects no nav —
// the existing application is byte-identical. This is the ONLY switch that mounts
// the Executive Brain surface on the client. It is independent of the backend
// per-capability *_ENABLED flags (those gate individual endpoints and cause the
// per-panel "capability not enabled" degradation, handled in brainApi/CapabilityGate).
export const EXEC_BRAIN_ENABLED =
  String(process.env.REACT_APP_EXEC_BRAIN_ENABLED).toLowerCase() === "true";
